import {
    createFormSelectionControlComponent,
    FormSelectionControl,
    FormSelectionControlState,
    ITEM_STATE_CHECKED,
    ITEM_STATE_DISABLED,
} from '@vfde-brix/form-selection-control';
import { setSalesChannel } from '../container/App/action';
import { SalesChannel } from '../enum';

const getSwitcherState = (salesChannel: SalesChannel): FormSelectionControlState | undefined => {
    switch (salesChannel) {
        case SalesChannel.CONSUMER:
            return undefined;
        case SalesChannel.YOUNG:
            return ITEM_STATE_CHECKED;
        default:
            return ITEM_STATE_DISABLED;
    }
};

const mountFormSelection = (setSales: typeof setSalesChannel, wrapperId: string) => {
    const container = document.getElementById(wrapperId);

    return container && createFormSelectionControlComponent(container, {
        onChange: ({ currentTarget }) => {
            if (currentTarget instanceof HTMLInputElement) {
                const sales = currentTarget.checked
                    ? SalesChannel.YOUNG
                    : SalesChannel.CONSUMER;

                setSales(sales);
            }
        },
    });
};

export const updateYoungSwitchState = (component: FormSelectionControl | null, salesChannel: SalesChannel) => {
    if (!component) {
        return;
    }

    const { items } = component.getProperties();

    if (items?.[0]) {
        items[0].optState = getSwitcherState(salesChannel);

        component.update({ items });
    }
};

export default mountFormSelection;
